import React from "react";

import { Stack } from "@mui/material";

import { useTheme } from "@fartherfinance/frontend/theme/ThemeProvider";

import { TableContainerV2 } from "@src/multiCustodian/components/Client/Portfolio/shared/shared";
import { AccordionSummary } from "@src/sharedComponents/Accordion/Accordion";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Switch from "@src/sharedComponents/Switch/Switch";

const LoadingHeader = () => {
  const {
    color: { $surfaceLow },
  } = useTheme();

  return (
    <Stack
      flex={1}
      direction={"row"}
      justifyContent={"space-between"}
      p={"19px 16px"}
      style={{ backgroundColor: $surfaceLow }}
    >
      <Stack direction={"row"} flex={1} borderRadius={"5px"}>
        <Skeleton width={400} />
      </Stack>

      <Stack borderRadius={"5px"} spacing={"12px"}>
        <Skeleton width={200} />
      </Stack>
    </Stack>
  );
};

const LoadingAccordionRow = () => (
  <AccordionSummary>
    <Stack direction={"row"} justifyContent={"space-between"} flex={1}>
      <Stack direction={"row"} spacing={2}>
        <Skeleton width={100} />
        <Stack borderRadius={"5px"}>
          <Skeleton width={120} />
        </Stack>
      </Stack>

      <Stack direction={"row"} spacing={2} textAlign={"center"}>
        <Skeleton width={100} />
        <Switch disabled={true} on={false} onClick={() => undefined} />
      </Stack>
    </Stack>
  </AccordionSummary>
);

const LoadingStateTable = () => {
  return (
    <TableContainerV2>
      <LoadingHeader />
      {new Array(3).fill(null).map((_, i) => (
        <LoadingAccordionRow key={i} />
      ))}
    </TableContainerV2>
  );
};

export { LoadingAccordionRow };

export default LoadingStateTable;
